/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ChartPieIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Chart Pie',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10,1.25c-2.53345,0-4.81165,1.0885-6.41089,2.8147-.01782.01611-.04028.02356-.05688.04175s-.02197.0415-.03638.06079c-1.39124,1.5498-2.24585,3.59082-2.24585,5.83276,0,2.40894.97852,4.59326,2.55884,6.177.00244.00256.00317.0061.00562.00854.00256.00256.0061.00317.00854.00562,1.58374,1.5802,3.76807,2.55884,6.177,2.55884,4.8252,0,8.75-3.9248,8.75-8.75S14.8252,1.25,10,1.25ZM9.25,8.30176l-4.06641-3.70581c1.10657-.98743,2.51172-1.64648,4.06641-1.80701v5.51282ZM4.17285,5.70435l4.74133,4.32092-4.53967,4.53967c-1.01416-1.24731-1.62451-2.83557-1.62451-4.56494,0-1.60876.53296-3.09167,1.42285-4.29565ZM10,17.25c-1.72937,0-3.31763-.61035-4.56494-1.62451l5.09521-5.09521c.00439-.00439.0061-.01086.01025-.01538.00415-.00427.01001-.00562.01416-.01001.02612-.02881.03662-.0647.05762-.09619.0271-.04065.06079-.07642.07983-.12207.00293-.0072.00366-.01465.00635-.02197.01733-.04578.01929-.09326.02734-.14087.00708-.04175.02417-.08179.02417-.12378V2.78894c3.64685.37646,6.5,3.46619,6.5,7.21106,0,3.99805-3.25195,7.25-7.25,7.25Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
